/*eslint-disable*/
import GoogleTag from './counters/GoogleTag.js'
import YandexMetrika from './counters/YandexMetrika.js'

const GA_TRACKING_ID = 'UA-117948579-1';
const YA_TRACKING_ID = '45818694';

class Counter {
  constructor () {
    this._init();
  }

  _init () {
    this.gtag = new GoogleTag(GA_TRACKING_ID);
    this.yaCounter = new YandexMetrika(YA_TRACKING_ID);
  }

  sendPage (to) {
    if (api.env.APP_ENV === 'production') {
      this.gtag.sendPage(to);
      this.yaCounter.sendPage(to);
    }
  }
}

export default new Counter();
